var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserGroups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 6C14.3546 6 15.25 5.10457 15.25 4C15.25 2.89543 14.3546 2 13.25 2C12.1454 2 11.25 2.89543 11.25 4C11.25 5.10457 12.1454 6 13.25 6ZM13.25 8C15.4591 8 17.25 6.20914 17.25 4C17.25 1.79086 15.4591 0 13.25 0C12.3041 0 11.4348 0.328359 10.75 0.877315C10.0652 0.328359 9.19595 0 8.25 0C6.04086 0 4.25 1.79086 4.25 4C4.25 6.20914 6.04086 8 8.25 8C9.19595 8 10.0652 7.67164 10.75 7.12269C11.4348 7.67164 12.3041 8 13.25 8ZM9.54918 5.52062C9.35635 5.05183 9.25 4.53833 9.25 4C9.25 3.46167 9.35635 2.94817 9.54918 2.47938C9.19968 2.1805 8.74592 2 8.25 2C7.14543 2 6.25 2.89543 6.25 4C6.25 5.10457 7.14543 6 8.25 6C8.74592 6 9.19968 5.8195 9.54918 5.52062ZM0.25 15.5C0.25 11.9101 3.16015 9 6.75 9H9.75C10.0888 9 10.4215 9.02591 10.7462 9.07587C11.0739 9.02588 11.4091 9 11.75 9H14.75C18.3399 9 21.25 11.9101 21.25 15.5C21.25 16.8807 20.1307 18 18.75 18H7.75H2.75C1.36929 18 0.25 16.8807 0.25 15.5ZM5.31289 16C5.27212 15.8198 5.25 15.6317 5.25 15.4382C5.25 13.6977 5.929 12.1445 7.02822 11H6.75C4.26472 11 2.25 13.0147 2.25 15.5C2.25 15.7761 2.47386 16 2.75 16H5.31289ZM7.25 15.4382C7.25 12.953 9.26472 11 11.75 11H14.75C17.2353 11 19.25 13.0147 19.25 15.5C19.25 15.7761 19.0261 16 18.75 16H7.75C7.47386 16 7.25 15.7144 7.25 15.4382Z",
    fill: "#003393"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroups);
export default __webpack_public_path__ + "static/media/user_groups.b940ad117ec5d5791cb7b8e74da5568c.svg";
export { ForwardRef as ReactComponent };